import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
// import { data } from "../../../util/constants";
import { useSelector } from "react-redux";
import { feeBarChartInfo } from "../../../api/dashboard";
import { CircularProgress, Typography } from "@material-ui/core";
import moment from "moment";

const getGMT4Date = (isoDate) => {
  // eslint-disable-next-line
  let date = new Date(isoDate);
  date.setHours(date.getHours() + 4);
  if (new Date(date).toISOString().split("T")[0]) {
    return new Date(date).toISOString().split("T")[0];
  } else {
    return moment().format("YYYY-MM-DD");
  }
};

export const BarChartComponent = () => {
  const [months, setMonths] = useState();
  const [loading, setLoading] = useState(false);
  const [firstRun, setFirstRun] = useState(true);
  const { schoolId, role, token } = useSelector((state) => state.user);
  const [name, setName] = useState("");
  const { t } = useTranslation();
  const [firstRunNoData, setFirstRunNoData] = useState(false);
  const [transactionLength, setTransactionLength] = useState();

  let startDate = moment()
    .subtract(2, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  let endDate = getGMT4Date(new Date().toISOString());

  const data = {
    labels: months,
    datasets: [
      {
        stack: "stack1",
        label: "Received",
        data: transactionLength,
        backgroundColor: "#2E6C7C",
        borderRadius: 5,
      },
    ],
  };

  const onChangeBarSelect = async (e) => {
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    setName(month[d.getMonth()]);

    try {
      setLoading(true);
      const value = e.target.value;

      if (value === "today") {
        setName("");
        startDate = getGMT4Date(new Date().toISOString());
        endDate = getGMT4Date(new Date().toISOString());
      }

      if (value === "lastMonth") {
        setName(month[d.getMonth() - 1]);
        startDate = moment()
          .subtract(0, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = getGMT4Date(new Date().toISOString());
      }
      if (value === "lastSix") {
        setName("");
        startDate = moment()
          .subtract(5, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = getGMT4Date(new Date().toISOString());
      }

      const id = schoolId;
      const userRole = role;
      const response = await feeBarChartInfo(
        startDate,
        endDate,
        id,
        userRole,
        token
      );
      if (response.status) {
        if (!response?.transactionsOfLength?.length) {
          setFirstRunNoData(true);
        } else if (value === "today") {
          setFirstRunNoData(false);
          setMonths(response?.monthsOfTransactions);
          setTransactionLength(response?.transactionsOfLength);
        } else if (value === "lastMonth") {
          setFirstRunNoData(false);
          setMonths(response?.monthsOfTransactions);
          setTransactionLength(response?.transactionsOfLength);
        } else if (value === "lastSix") {
          setFirstRunNoData(false);
          setMonths(response?.monthsOfTransactions);
          setTransactionLength(response?.transactionsOfLength);
        }
      }
      setLoading(false);
    } catch (error) {}
  };

  const onGetTodayData = () => {
    setTimeout(() => {
      if (firstRun) {
        let event = {
          target: {
            value: "lastMonth",
          },
        };
        setFirstRun(false);
        onChangeBarSelect(event);
      }
    });
  };

  useEffect(() => {
    onGetTodayData();
  }, []);

  return (
    <div className="card card-style bar-chart-card">
      <div className="card-head">
        <Typography variant="body1">{t("text_recent_transactions")}</Typography>
        {/* <Typography variant="body1">{name}</Typography> */}
        {role === "readOnly" ? (
          <select
            className="form-select shadow-sm my-select"
            disabled
            onChange={onChangeBarSelect}
          >
            <option value="" defaultValue disabled>
              {t("text_select_period")}
            </option>
            <option value="today">{t("text_today")}</option>
            <option selected={true} value="lastMonth">
              {t("text_current_month")}
            </option>
            <option value="lastSix">{t("text_last_6_months")}</option>
          </select>
        ) : (
          <select
            className="form-select shadow-sm my-select"
            onChange={onChangeBarSelect}
          >
            <option value="" disabled>
              {t("text_select_period")}
            </option>
            <option value="today">{t("text_today")}</option>
            <option selected value="lastMonth">
              {t("text_current_month")}
            </option>
            <option value="lastSix">{t("text_last_6_months")}</option>
          </select>
        )}
      </div>

      <div className="card-body">
        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_details")}
          </div>
        ) : firstRunNoData ? (
          <div className="no-pending-receive">
            <Typography variant="body1">No Recent Transactions</Typography>
          </div>
        ) : (
          <div className="chart-wrapper">
            <Bar
              data={data}
              height={400}
              options={{
                maintainAspectRatio: false,
                barPercentage: 0.7,
                barThickness: 60,
                plugins: {
                  legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                      usePointStyle: true,
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.formattedValue}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        family: "Montserrat",
                      },
                    },
                  },
                  y: {
                    grid: {
                      display: false,
                    },
                    position: "right",
                    ticks: {
                      font: {
                        family: "Montserrat",
                      },
                    },
                  },
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
